import React, { useEffect, useState } from "react";
import { DollarSign, AlertCircle, TrendingUp } from "lucide-react";
import {
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  Chart
} from "chart.js";
import { Line, Bar, Doughnut } from "react-chartjs-2";

// Registre os componentes do Chart.js
Chart.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

const Resumo = () => {
  const [data, setData] = useState({
    dinheiroNaRuaNormal: 0,
    jurosMensaisNormal: 0,
    dinheiroNaRuaAtrasado: 0,
    jurosMensaisAtrasado: 0,
    atrasados: 0,
    detalhesAtrasados: [],
    detalhesJurosMensais: [],
    contas_receber: 0,
    contas_saida: 0,
  });

  const [showAtrasados, setShowAtrasados] = useState(false);
  const [showJurosMensais, setShowJurosMensais] = useState(false);
  const idUsuario = localStorage.getItem("idUsuario");

  useEffect(() => {
    const url = `https://sismoney.com/painel/database_dashboard.php?idUsuario=${idUsuario}`;

    fetch(url)
      .then((response) => response.json())
      .then((res) => {
        if (res.success) {
          console.log(res)
          setData(res);
        } else {
          console.error(res.message);
        }
      })
      .catch((error) => console.error("Erro ao buscar os dados:", error));
  }, [idUsuario]);

  const months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun'];

  const lineChartData = {
    labels: months,
    datasets: [
      {
        label: 'Empréstimos',
        data: [data.dinheiroNaRuaNormal, data.dinheiroNaRuaNormal, data.dinheiroNaRuaNormal, data.dinheiroNaRuaNormal, data.dinheiroNaRuaNormal, data.dinheiroNaRuaNormal],
        borderColor: 'rgb(99, 102, 241)',
        backgroundColor: 'rgba(99, 102, 241, 0.5)',
        tension: 0.4,
      },
      {
        label: 'Pagamentos',
        data: [data.jurosMensaisNormal, data.jurosMensaisNormal, data.jurosMensaisNormal, data.jurosMensaisNormal, data.jurosMensaisNormal, data.jurosMensaisNormal],
        borderColor: 'rgb(34, 197, 94)',
        backgroundColor: 'rgba(34, 197, 94, 0.5)',
        tension: 0.4,
      },
    ],
  };

  const barChartData = {
    labels: months,
    datasets: [
      {
        label: 'Juros Recebidos',
        data: [data.jurosMensaisAtrasado, data.jurosMensaisAtrasado, data.jurosMensaisAtrasado, data.jurosMensaisAtrasado, data.jurosMensaisAtrasado, data.jurosMensaisAtrasado],
        backgroundColor: 'rgba(99, 102, 241, 0.5)',
      },
    ],
  };

  const doughnutData = {
    labels: ['Em Dia', 'Atrasados', 'Quitados'],
    datasets: [
      {
        data: [100 - data.atrasados, data.atrasados, 0],
        backgroundColor: [
          'rgba(34, 197, 94, 0.6)',
          'rgba(239, 68, 68, 0.6)',
          'rgba(99, 102, 241, 0.6)',
        ],
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
    },
  };

  const toggleAtrasados = () => {
    setShowAtrasados(!showAtrasados);
  };

  const toggleJurosMensais = () => {
    setShowJurosMensais(!showJurosMensais);
  };

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-800 dark:text-white">Visão Geral</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[
          { title: 'Dinheiro na Rua Normal', value: data.dinheiroNaRuaNormal, isMoney: true, color: 'green', icon: <DollarSign className="w-6 h-6 text-green-500" /> },
          { title: 'Juros Mensais a Receber (Normais)', value: data.jurosMensaisNormal, isMoney: true, color: 'blue', icon: <TrendingUp className="w-6 h-6 text-blue-500" />, onClick: toggleJurosMensais },
          { title: 'Dinheiro na Rua Atrasado', value: data.dinheiroNaRuaAtrasado, isMoney: true, color: 'red', icon: <AlertCircle className="w-6 h-6 text-red-500" /> },
          { title: 'Juros Mensais a Receber (Atrasados)', value: data.jurosMensaisAtrasado, isMoney: true, color: 'blue', icon: <TrendingUp className="w-6 h-6 text-blue-500" /> },
          { title: 'Atrasados', value: data.atrasados, isMoney: false, color: 'red', icon: <AlertCircle className="w-6 h-6 text-red-500" />, onClick: toggleAtrasados },
          { title: 'Contas a receber', value: data.contas_receber, isMoney: true, color: 'green', icon: <AlertCircle className="w-6 h-6 text-red-500" /> },
          { title: 'Contas a pagar', value: data.contas_saida, isMoney: true, color: 'red', icon: <AlertCircle className="w-6 h-6 text-red-500" /> },
        
        ].map((item, index) => (
          <div key={index} className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-6 transition-colors duration-200 cursor-pointer" onClick={item.onClick}>
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-200">{item.title}</h3>
              {item.icon}
            </div>
            <p className={`text-2xl font-bold text-${item.color}-600 dark:text-${item.color}-400`}>
              {item.isMoney
                ? `R$ ${Number(item.value).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                : item.value}
            </p>

            {/* Exibir detalhes dos atrasados dentro da mesma área */}
            {showAtrasados && item.title === "Atrasados" && (
              <div className="mt-4">
                {data.detalhesAtrasados.length > 0 ? (
                  <ul className="space-y-2">
                    {data.detalhesAtrasados.map((detalhe, idx) => (
                      <li key={idx} className="flex justify-between items-center text-gray-700 dark:text-gray-200">
                        <div>
                          <p className="font-semibold">{detalhe.nome}</p>
                          <p className="text-sm text-gray-500 dark:text-gray-400">{`Data de Atraso: ${detalhe.data}`}</p>
                        </div>
                        <p className="text-lg font-semibold">{`R$ ${Number(detalhe.valor).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</p>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-gray-500 dark:text-gray-400">Nenhum atraso encontrado.</p>
                )}
              </div>
            )}

            {/* Exibir detalhes dos juros mensais dentro da mesma área */}
            {showJurosMensais && item.title === "Juros Mensais a Receber (Normais)" && (
              <div className="mt-4">
                {data.detalhesJurosMensais.length > 0 ? (
                  <ul className="space-y-2">
                    {data.detalhesJurosMensais.map((detalhe, idx) => (
                      <li key={idx} className="flex justify-between items-center text-gray-700 dark:text-gray-200">
                        <div>
                          <p className="font-semibold">{detalhe.nome}</p>
                          <p className="text-sm text-gray-500 dark:text-gray-400">{`Data de Recebimento: ${detalhe.data}`}</p>
                        </div>
                        <p className="text-lg font-semibold">{`R$ ${Number(detalhe.valor).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</p>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-gray-500 dark:text-gray-400">Nenhum juros mensal encontrado.</p>
                )}
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-6 transition-colors duration-200">
          <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-200 mb-4">Evolução de Empréstimos</h3>
          <div className="h-80">
            <Line data={lineChartData} options={chartOptions} />
          </div>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-6 transition-colors duration-200">
          <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-200 mb-4">Juros Mensais</h3>
          <div className="h-80">
            <Bar data={barChartData} options={chartOptions} />
          </div>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-6 transition-colors duration-200 lg:col-span-2">
          <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-200 mb-4">Status dos Empréstimos</h3>
          <div className="h-80 max-w-md mx-auto">
            <Doughnut data={doughnutData} options={chartOptions} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resumo;
